// extracted by mini-css-extract-plugin
export default {"root":"Main_root__I2i7J","block":"Main_block__gL1qK"};